<template>
  <div class="container">
  </div>
</template>
<style scoped>
.container{
  overflow-y: scroll;
  /* font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"; */
  color: rgb(34,34,34);
}
</style>

<script>
import { getToken } from '../apollo/apollo'
export default {
   components: {

  },
  data() {
    return {
      getToken:getToken,
      area:""

    }
  },
  computed:{

  },
  created() {


  },
  mounted(){
    this.initData()
  },
  methods: {
    initData() {
      var code = this.getQueryVariable('code')
      sessionStorage.setItem('code',code)
      //从微信分享进入
      if(sessionStorage.getItem('share')=='1'){
        window.location.href="https://screen.xiaoyima.work/index.html?code="+code+"&article_id="+sessionStorage.getItem('article_id')+"&user_id="+sessionStorage.getItem('user_id')+'&title='+sessionStorage.getItem('title')+"&state=123#/share"
      }else{
        //正常微信注册
        this.area = 'snsapi_userinfo';
         if(this.getQueryStringOne('article')!=null){//进入干货详情
          sessionStorage.setItem('share','3');
          sessionStorage.setItem('article_id',this.getQueryStringOne('article'));
        }
        if(code){
            var formDate={
              code:code,
              area:this.area,
              user_id:0,
              article_id:0,
            }
            getToken(formDate).then(res=>{
              var login=JSON.parse(res.data.login)
              sessionStorage.setItem('headimgurl',login.data.headimgurl)
              sessionStorage.setItem('nickname',login.data.nickname)
              sessionStorage.setItem('Authorization',login.data.Authorization);
              sessionStorage.setItem('user_id',login.data.user_id);
              this.$store.state.status=login.data.status

              this.jump('./index')
            })
              .catch(err=>{
                alert(err)
              })
        }else{
            var appid = 'wx1ebfca7e067859a6';
            var redirect_uri = encodeURI('https://screen.xiaoyima.work/index.html');
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+appid+"&redirect_uri="+redirect_uri+"&response_type=code&scope="+this.area+"&state=STATE#wechat_redirect"
            // switch (this.area){
            //     case 'snsapi_base':
            //     window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+appid+"&redirect_uri="+redirect_uri+"&response_type=code&scope="+this.area+"&state=123#wechat_redirect"
            //     break;
            //     default:
            //     window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+appid+"&redirect_uri="+redirect_uri+"&response_type=code&scope="+this.area+"&state=STATE#wechat_redirect"
            //     break;
            // }
        }
      }

    },
    //获取参数
      getQueryStringOne(name) {
            var url=JSON.stringify(window.location.href)
            // var url=JSON.stringify('https://screen.xiaoyima.work/index.html?user_id=2723&article_id=111#/share')
            url=url.replace('?','&')
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = url.substr(1).match(reg);
		    return r?unescape(decodeURIComponent(r[2])):null;
        },
    getQueryVariable(variable)
    {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
        }
        return(false);
    }



  },
  destroyed () {


  },
  watch:{

  }
};
</script>



// WEBPACK FOOTER //
// src/views/login.vue